module.exports = __webpack_public_path__ + "static/media/4-redcube.1067c87e.png";